import { Sha256 } from "@aws-crypto/sha256-browser";
const MODE = process.env.NODE_ENV;

function ksort(o) {
  //参数ksort排序(key按照字母顺序)
  let sorted = {}, keys = Object.keys(o);
  keys.sort();
  keys.forEach((key) => {
    sorted[key] = o[key];
  });
  return sorted;
}

function uint8ArrayToHex(uint8Array) {
  const hexArray = Array.from(new Uint8Array(uint8Array));
  return hexArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

// 双重sha265加密
async function doubleSha256(sign) {
  const hash = new Sha256();
  hash.reset();
  hash.update(sign);
  sign = uint8ArrayToHex(await hash.digest());
  hash.reset();
  hash.update(sign);
  return uint8ArrayToHex(await hash.digest());
}

// 获取验签对象信息
export default async function (pa) {
  let secret = "";
  if (MODE === "development" || MODE === "test") {
    secret = "cb73f5967547633f6a5989756ca258d9";
  } else {
    secret = "053c2f8e7363e63487021c8e48af46c1";
  }
  const headerObj = {
    platform: "pc",
    version: "1.0.0",
    nonce: Math.random().toString(36).slice(-8),
    timestamp: Math.floor(Date.now() / 1000),
    "Api-Version": "v1",
  };
  pa = {
    ...pa,
    ...headerObj,
  };
  pa = ksort(pa);
  let sign = "";
  for (let key in pa) {
    if (pa[key] != undefined) {
      if(Array.isArray(pa[key])){
        let arr = JSON.stringify(pa[key])
        arr = escapeSpecialChars(arr)
        sign = sign + key + "=" + arr + "&";
      }else{
        sign = sign + key + "=" + pa[key] + "&";
      }
    }
  }
  sign = sign + secret;
  sign = await doubleSha256(sign);
  return {
    ...headerObj,
    sign: sign,
  };
}